import { FC, memo } from "react";
import { Box, FormControl, FormControlProps, FormLabel, SxProps, Theme, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Help } from "components/Help";
import styles from "./styles";

export type ToggleGroupProps = Omit<FormControlProps, "onChange"> & {
  name: string;
  label: string;
  selected: string | number;
  help?: string;
  radio?: boolean;
  size?: "small" | "medium" | "large";
  fullWidth?: boolean;
  compact?: boolean;
  options: Array<{
    label: string;
    value: string | number;
    description?: string;
  }>;
  sx?: SxProps<Theme>;
  onChange: (name: string, value: string) => void;
};

const ToggleGroup: FC<ToggleGroupProps> = ({ name, label, help, selected, radio, size = "medium", fullWidth, compact, options, sx, onChange, ...rest }) => (
  <FormControl component="fieldset" sx={{ ...styles.control, ...{ width: fullWidth ? "100%" : "auto" }, ...sx }} {...rest} className="RlxToggleGroup">
    <FormLabel component="legend" sx={styles.label}>
      {label}
      {help && <Help text={help} />}
    </FormLabel>
    <ToggleButtonGroup
      exclusive
      fullWidth
      size={size}
      value={selected}
      onChange={(_, value) => {
        if (radio && !value) return;
        onChange(name, value);
      }}
    >
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          color="primary"
          sx={{ ...styles.button, ...(compact ? { padding: "calc(0.5 * var(--rhythm))" } : {}) }}
        >
          {option.label}
          {option.description && (
            <Box component="small" sx={styles.description}>
              {option.description}
            </Box>
          )}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  </FormControl>
);

ToggleGroup.displayName = "ToggleGroup";

export default memo(ToggleGroup);
